import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import GoldStandardObservations from '../components/GoldStandardObservations';
import { doFlash } from '../actions/flash';
import { fetchObservations, updateObservation } from '../actions/observations';

let mapStateToProps = function(state) {
	return {
		observations: state.observations.list,
		isFetchingObservations: state.observations.isFetching
	};
};

let mapDispatchToProps = {
	doFlash,
	fetchObservations,
	updateObservation
};

module.exports = connect(mapStateToProps, mapDispatchToProps)(GoldStandardObservations);



// WEBPACK FOOTER //
// ./frontend/olos/js/containers/GoldStandardObservations.jsx